import type { LWApiPublicAssetDetailsResultRawI } from '@liquidweb-dev/club-sauce/public/asset/index.raw';
import { acronisProductCodes } from 'utility/acronisProductMap';
import useAssetNewOrderedAddOns from './useAssetNewOrderedAddOns';

/**
 * Tells whether an Acronis backup was ordered for one server that the server's
 * association details do not list yet. `isLoading` stays true until the ordered
 * add-ons have loaded.
 */
const useAssetNewOrderedBackups = (
	asset?: Pick<
		LWApiPublicAssetDetailsResultRawI,
		'uniq_id' | 'associationDetails'
	>,
) => {
	const { assetNewOrderedAddOns, isLoading } = useAssetNewOrderedAddOns(asset);

	return {
		isNewOrderedBackups: assetNewOrderedAddOns.some(({ code }) =>
			acronisProductCodes.includes(code),
		),
		isLoading,
	};
};

export default useAssetNewOrderedBackups;
